/* eslint-disable prettier/prettier */
import { Button, Container, Dropdown, Form, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import coinIcon from 'assets/images/coin.svg'
import BaseModal from './BaseModal'
import { useAtom } from 'jotai'
import { roomImageAtom } from 'config/store'
import { PATHS } from 'config/routes'
import { Link, useParams } from 'react-router-dom'
import HomeSliderMobile from 'pages/HomePage/components/HomeSliderMobile'
import { randomIntFromInterval } from 'utils/helpers'
import { useState } from 'react'
import { makeData } from 'utils/makeData'
import { getAllGameQuery, useCreateRoomOfGame } from 'dataLayer/game'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { showSnackbar } from 'store/actions'
import { useQuery } from 'react-query'

function CreateRoomModal({
	show,
	onHide,
	title,
	friendPage,
	friendMobile,
	...otherProps
}) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { roomId } = useParams()
	const dispatch = useDispatch()
	const [roomImage] = useAtom(roomImageAtom)
	const { data: games } = useQuery(getAllGameQuery())
	const itemGameSelect = games && games.find(it => it.id == roomId)

	const gameData = makeData('game', 5)
	const [gameSelect, setGameSelect] = useState(gameData?.[0]?.game)
	const [playroom, setPlayroom] = useState(null)
	const [coin, setCoin] = useState("");
	const [password, setPassword] = useState("");

	const [infoData, setInfoData] = useState({
		game_id: parseInt(roomId),
		coin: '',
		password: ''
	})
	function handleInfoChange(e) {
		const newInfoData = { ...infoData }
		newInfoData[e.target.name] = e.target.value
		setInfoData(newInfoData)
	}

	function handleGame(item) {
		setGameSelect(item?.game)
		setPlayroom(item?.id)
	}

	const _createGameSuccess = (result) => {
		if (!result.status) {
			dispatch(showSnackbar(true, result.message || t('modal.error'), 'error'))
		} else {
			navigate(PATHS.PLAYROOM_PAGE.replace(':roomId', result.data.room.game_id).replace(
				':gameId',
				result.data.room.id
			))
			dispatch(showSnackbar(true, t('modal.success'), 'success'))
		}
	}
	const { mutate, isLoading } = useCreateRoomOfGame(_createGameSuccess)

	const onPressCreateRoom = () => {
		if (isLoading) return;
		if (infoData.coin <= 0 || isNaN(parseInt(infoData.coin))) {
			dispatch(showSnackbar(true, 'Please enter Coin' || t('modal.error'), 'error'))
		} else {
			mutate(infoData);
		}
	}
	return (
		<BaseModal show={show} onHide={onHide} {...otherProps}>
			<Container className="baseinput-container modal-createroom" fluid>
				<Modal.Header>
					<Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
					{friendPage ? (
						friendMobile ? (
							<Dropdown align="end">
								<Dropdown.Toggle>{gameSelect}</Dropdown.Toggle>
								<Dropdown.Menu>
									{gameData?.map(item => (
										<Dropdown.Item
											key={item?.id}
											onClick={() => handleGame(item)}
										>
											{item?.game}
										</Dropdown.Item>
									))}
								</Dropdown.Menu>
							</Dropdown>
						) : (
							<HomeSliderMobile isCreateRoom={true} isFriendPage={true} />
						)
					) : (
						<img src={itemGameSelect?.image || roomImage} alt="Room game" />
					)}
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Form.Group className="mb-3 base-input createroom-input">
							<img src={coinIcon} width={36} height={36} alt="Coin's bet" />
							<Form.Control
								type="tel"
								placeholder={t('modal.create_room.gold_bet')}
								name="coin"
								onChange={handleInfoChange}
							/>
						</Form.Group>
						<Form.Group
							className="mb-3 base-input createroom-input"
							controlId="formBasicPassword"
						>
							<Form.Control
								type="password"
								name="password"
								placeholder={t('modal.create_room.room_pass')}
								onChange={handleInfoChange}
							/>
						</Form.Group>
					</Form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="dark" onClick={onHide}>
						{t('modal.btn.cancel')}
					</Button>
					{/* <Link
						to={
							friendMobile
								? PATHS.PLAYROOM_PAGE.replace(':roomId', playroom).replace(
									':gameId',
									randomIntFromInterval(100000, 999999),
								)
								: PATHS.PLAYROOM_PAGE.replace(':roomId', roomId).replace(
									':gameId',
									randomIntFromInterval(100000, 999999),
								)
						}
					> */}
					<Button onClick={onPressCreateRoom} variant="secondary">{t('modal.btn.agree')}</Button>
					{/* </Link> */}
				</Modal.Footer>
			</Container>
		</BaseModal>
	)
}

export default CreateRoomModal
